import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// Icons
import {
  AiOutlineSearch,
} from "react-icons/ai";

// Service
import { logControlService } from '../../Services/logControl.service';
import { toDateTimeISOStringFormat } from "../../Services/string.service";

// Components
import { ToastComponent } from "../Components/ToastComponent";
import LongTable from "../Components/Tables/LongTable";
import Spinner from "../Components/Spinner";
import JsonToForm from "../Components/Modals/JsonToForm-modal";
import DateRangePickers from "../Components/Forms/DateRangePickers";
import { useTranslation } from "react-i18next";

export default function LogsControl() {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  dispatch({ type: "title", value: t("TITLE.LOGS") });

  const [loading, setLoading] = useState(false);
  const [toastParams, setToastParams] = useState('');
  const [operationTypes, setOperationTypes] = useState([]);
  const [operationType, setOperationType] = useState(0);
  const [logList, setLogList] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState(null);

  const listColumns = [t("LOGS_CONTROL.ID"), t("LOGS_CONTROL.TYPE"), t("LOGS_CONTROL.DESCRIPTION"), t("LOGS_CONTROL.DATE")];
  const listFieldColumns = ["logId", "operationTypeName", "request", "dateTimeOperation"];

  const [initialDateTime, setInitialDateTime] = useState(toDateTimeISOStringFormat(new Date(new Date().setDate(new Date().getDate() - 2))).replace("Z", ""));
  const [endDateTime, setEndDateTime] = useState(toDateTimeISOStringFormat(new Date()).replace("Z", ""));

  const fetchOperationTypes = async () => {
    setLoading(true);

    try {
      console.log('🐗: fetchOperationTypes');
      var response = await logControlService.fetchOperationTypes();
      setOperationTypes(response);

    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false);
    }

  };

  const onSearch = async () => {
    setLoading(true);

    console.log('🐗: onSearch');

    try {
      var payload = {
        "operationTypeId": operationType,
        "dateStart": toDateTimeISOStringFormat(initialDateTime),
        "dateEnd": toDateTimeISOStringFormat(endDateTime),
        "pageNumber": 1,
        "pageSize": 50
      };

      setLogList(await logControlService.search(payload));
      
    } catch (error) {
      console.log("Erro na busca:.");
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };

  const onTableRowView = (item) => {
    setDetails(item.message);
    setShowDetails(true);
  };

  const handleCloseDetails = () => { 
    setShowDetails(false);
  };

  useEffect(() => {
    (async () => {
      await fetchOperationTypes();
    })();
  }, []);

  return (
    <>
      <div className='container-xxl flex-grow-1 container-p-y'>

        <ToastComponent params={toastParams} closeToast={() => setToastParams(JSON.stringify({ show: false }))} />

        {loading ? <Spinner /> : ""}

        <JsonToForm
          show={showDetails}
          json={details}
          handleClose={handleCloseDetails} />

        <div className="row py-5" >

          <div className="col-6">
            <DateRangePickers setInitialDateTime={setInitialDateTime} setEndDateTime={setEndDateTime} />
          </div>

          <div className="col-4">
            <div className="input-group">
              <span className="input-group-text text-primary">
                {t("LOGS.OPERATION_TYPE")}
              </span>
              <select
                name="operationType"
                id="operationType"
                className="form-control"
                onChange={(e) => setOperationType(e.target.value)}
              >
                <option value="0">--{t("LOGS.OPERATION_TYPE")}--</option>
                {operationTypes && operationTypes.map((item, index) => (
                  <option key={index} value={item.operationTypeId}>{item.name}</option>
                ))}


              </select>
            </div>
          </div>

          <div className="col-2">
            <button
              type="button"
              className="btn btn-primary"
              onClick={async () => onSearch()}
            >
              <AiOutlineSearch className="icon-in-button" />
              {t("LOGS.SEARCH_BUTTON")}
            </button>
          </div>

        </div>
        {logList?.length > 0 ? (

          <LongTable
            data={logList}
            columns={listColumns}
            fields={listFieldColumns}
            onView={onTableRowView}
          />
        ) : ("")}


      </div>
    </>);

};